import { Injectable, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SharedFormResetService {
  private resetIt: EventEmitter<any> = new EventEmitter();
  toggleReset = this.resetIt.asObservable();

  private titleIt: EventEmitter<any> = new EventEmitter();
  changeTitle = this.titleIt.asObservable();

  private statIt: EventEmitter<any> = new EventEmitter();
  private status = new BehaviorSubject({});
  currentMessage = this.status.asObservable();
  changeStats = this.statIt.asObservable();

  private incomingRequest: EventEmitter<any> = new EventEmitter();
  pushRequest = this.incomingRequest.asObservable();

  private crumbIt: EventEmitter<any> = new EventEmitter();
  changeCrumbs = this.crumbIt.asObservable();

  private incomingPicker: EventEmitter<any> = new EventEmitter();
  pickRequest = this.incomingPicker.asObservable();

  askToReset(change: any) {
    this.resetIt.next(change);
  }

  askToChangeTitle(title: string) {
    this.titleIt.next(title);
  }

  sendStats(stats: any) {
    this.statIt.next(stats);
  }

  updateRequest(request: any) {
    this.incomingRequest.next(request);
  }

  updatePicker(pick: any) {
    this.incomingPicker.next(pick);
  }

  askToChangeCrumbs(crumbs: any[]) {
    this.crumbIt.next(crumbs);
  }
  clearInput(val) {
    this.status.next(val);
  }
  constructor() {}
}